import Cookie from '@/libs/utils/cookie'

let host = ''
switch (location.host) {
    case 'd-wyc.yun-sk.com':
        host = 'd-dzsy.yun-sk.com'
        break
    case 't-wyc.yun-sk.com':
        host = 't-dzsy.yun-sk.com'
        break
    case 'g-wyc.yun-sk.com':
        host = 'g-dzsy.yun-sk.com'
        break
    case 'wyc.yun-sk.com':
        host = 'dzsy.yun-sk.com'
        break
}
const dzsyHost = `http://${host}/sys/#/`
export function getDzsyAuthPage (to = '') {
    let auth = Cookie.getCookie('auth') || localStorage.getItem('wycAuth')
    // let auth = localStorage.getItem('wycAuth')
    return `${dzsyHost}redirect-auth?auth=${auth}&to=${to}`
}

export const dszyLoginPage = `${dzsyHost}login`


// WEBPACK FOOTER //
// ./src/config/dzsy.js